import React from 'react'
import ConfirmationModal from '../../../shared/confirmationModal'
import { Box, Typography } from '@mui/material';

const ConfirmationDelete = (props) => {
    const {open, onClosed, onConfirms} = props;
  return (
    <ConfirmationModal
                open={open}
                onClose={onClosed}
                content={<Box>
                    <Typography className='mb-20px mt-20px' variant="body1">
                        Are you sure you want to delete this action?
                    </Typography>
                    <Box className='mb-20px mt-20px'>
                        <Typography variant="body2" color="error">
                            Warning: This action cannot be undone!
                        </Typography>
                    </Box>
                </Box>}
                title={<Typography className='queries-table-title'>Delete</Typography>}
                primaryButtonText={"Confirm"}
                onConfirm={onConfirms}
            />
  )
}

export default ConfirmationDelete